import { getApigeeUrl } from '@eu-data-act/react-euda-commons/dist/index';

const baseUrn = {
  deviceMapping: getApigeeUrl('deviceMapping'),
  deviceTelemetry: getApigeeUrl('deviceTelemetry'),
  telemetryDelivery: getApigeeUrl('telemetryDelivery')
};

const apiConfig = {
  routes: {
    deviceCategories: {
      urn: '/device-categories'
    },
    deviceMappingRequests: {
      urn: '/device-mapping-requests'
    },
    deviceTelemetryRequests: {
      urn: '/device-telemetry-requests'
    }
  },
  jsonapi: {
    types: {
      categories: 'device-category',
      deviceMapping: 'device-mapping-request',
      deviceTelemetry: 'device-telemetry-request'
    }
  }
};

export const api = {
  baseUrn,
  routes: apiConfig.routes,
  jsonapi: apiConfig.jsonapi
};
